//config
import { API_INTEGRATION_ID } from "../config";
import orderStatus from "../config/orderStatus";

//interface
import { IBaseModel } from "../interfaces/base";
import {
  IPartnerMenuItemRequestModel,
  IPartnerMenuItemUpdateRequestModel,
  IPartnerMenuUploadRequestModel,
} from "../interfaces/menu";
import {
  IPartnerOrderListRequestModel,
  IPartnerOrderRequestModel,
  IPartnerReportRequestModel,
} from "../interfaces/order";
import { IPatchCartOrderItemRequestModel } from "../interfaces/patchCart";
import { IPartnerProvisonRequestModel } from "../interfaces/provision";
import { IPartnerStoreRequestModel } from "../interfaces/store";

//API Request Object Models for Orders

export const orderListRequestModel: IPartnerOrderListRequestModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  POSStatusKey: orderStatus.all,
  OrderDate: undefined,
  PageNo: 1,
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
};

export const baseRequestModel: IBaseModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
};

export const statusForBtnsRequestModel: IPartnerOrderRequestModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  OrderId: "",
  PartnerOrderId: 0,
  POSStatusKey: 0,
  OrderDate: undefined,
  OrderTypeKey: 0,
  DenyOrCancelReasonCode: "",
  ApiKey: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  CurrentPOSStatusCode: "",
  DenyOrCancelReasonKey: 1,
  OrderReference: "",
};

export const orderRequestModel: IPartnerOrderRequestModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  OrderId: "",
  PartnerOrderId: 0,
  POSStatusKey: 0,
  OrderDate: undefined,
  OrderTypeKey: 0,
  DenyOrCancelReasonCode: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  CurrentPOSStatusCode: "",
  DenyOrCancelReasonKey: 1,
  OrderReference: "",
};

export const patchCartOrderItemRequestModel: IPatchCartOrderItemRequestModel = {
  OrderId: "",
  PatchCartPartnerOrderItems: [],
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  RequestingUser: 0,
  RequestingId: "",
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
};

export const reportRequestModel: IPartnerReportRequestModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  OrderId: "",
  PartnerOrderId: 0,
  POSStatusKey: 0,
  OrderDate: undefined,
  fromDate: undefined,
  toDate: undefined,
  OrderTypeKey: 0,
  DenyOrCancelReasonCode: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  CurrentPOSStatusCode: "",
  DenyOrCancelReasonKey: 1,
  OrderReference: "",
};

//API Request Object Models for Menus

export const menuUploadRequestModel: IPartnerMenuUploadRequestModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  IsSpecialInstructionEnable: false,
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
};

export const menuListRequestModel: IPartnerMenuItemRequestModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  IsSpecialInstructionEnable: false,
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  PartnerMenuItemList: [],
  FilteredMenuItemCount: 0,
};

export const menuItemUpdateRequestModel: IPartnerMenuItemUpdateRequestModel = {
  ItemKey: 0,
  ItemCode: "",
  IsDiscontinued: false,
  IsPartnerItem: false,
  SalesPrice: 0,
  OptionalSalesPrice: 0,
  RequestId: "",
  IntegrationId: "",
  ApiKey: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  RequestingUser: 0,
  RequestingId: "",
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
};

//API Request Object Models for Store
export const partnerStoreStatusSetRequestModel: IPartnerStoreRequestModel = {
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  RequestingUser: 0,
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  RequestingId: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  StoreStatusCode: "",
  StorePausedUntilTime: "",
  StorePauseReason: "",
};

//API Request Object Models for Provison

export const setupProvisionRequestModel: IPartnerProvisonRequestModel = {
  EmailAddress: "",
  RequestId: API_INTEGRATION_ID,
  IntegrationId: API_INTEGRATION_ID,
  ApiKey: "",
  UID: {
    CompanyKey: 0,
    LocationKey: 0,
    UserKey: 0,
    EnvironmentName: "",
    IsUrbanPiper: false,
  },
  RequestingUser: 0,
  RequestingId: "",
  Schema: "",
  ValidationMessages: [],
  IsApprovedStatus: 0,
  IsActive: 0,
  PartnerStore: {
    PartnerStoreId: "",
    PartnerStoreName: "",
    PartnerStoreCode: "",
    UserLocationInOurSystem: null,
    ContactEmails: [],
    AveragePreparationTime: 0,
    IsProvisionEnabled: false,
  },
};
